<template>
  <v-row justify="center">
    <v-col class="py-0">
      <div class="tcdc-ebook-card" @click="onPress()">
        <span class="tcdc-ebook-card-inside pa-5">
          <img :src="img" class="tcdc-ebook-image" />
        </span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['img'],
  methods: {
    onPress() {
      this.$emit('onPress');
    }
  }
};
</script>

<style lang="scss" scoped>
.tcdc-ebook-card {
  overflow: hidden;
  height: 0;
  padding-top: 100%;
  background-color: white;
  position: relative;
  cursor: pointer;
  /* display: flex;
  align-items: center;
  justify-content: center; */
}
.tcdc-ebook-card-inside {
  position: absolute;
  width: 100%;
  height: 100%;
  /* max-width: 80%;
  max-height: 80%; */
  top: 50%;
  bottom: 0;
  left: 50%;
  right: 0;
  transform: translate(-50%, -50%);
  border: 1px solid #b0b0b0;

  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;

  /* margin-left: -20px; */
  /* text-align: center; */
  /* position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto; */
  /* margin-left: auto;
  margin-right: auto; */
  /* width: 100%;
  height: 100%; */
}
.tcdc-ebook-image {
  height: 100%;
  object-fit: contain;
  /* max-width: 100%;
  max-height: 100%; */
}
</style>
